import { withTypography } from 'components/ui';

export const PriceAndCaloriesText = withTypography({
  variant: 'copyTwo',
  textAlign: 'center',
  numberOfLines: 1,
  adjustsFontSizeToFit: true,
  m: '$0',
  p: '$0',
});

export const Price = withTypography({ variant: 'copyTwo', bold: true });
